import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { development } from "../../libs/utils/Const";
import moment from 'moment';
const styles = StyleSheet.create({


    tableContainer: {
        width: '97%',
        margin: '15 auto',
    },
    content: {
        flexDirection: 'row',
        display: 'flex',
    },
    col: {
        width: '100%',
    },
    col10: {
        width: '83.3%',
    },
    col8: {
        width: '66.6%',
    },
    col7: {
        width: '58.3%',
    },
    col6: {
        width: '50%',
    },
    col5: {
        width: '41.6%',
    },
    col4: {
        width: '33.3%',
    },
    col3: {
        width: '25%',
    },
    col2: {
        width: '16.6%',
    },
    col1: {
        width: '8.3%',
    },
    logo: {
        width: 110,
        height: 50,
    },
    textLeft: {
        textAlign: 'left',
        paddingTop: '1px',
        fontSize: 9,
    },
    textRight: {
        textAlign: 'right',
        padding: '1px 5px 0px 0px',
        fontSize: 9,
    },

    termsContainer: {
        width: '100%',
        margin: '15 auto',
        paddingLeft: 5,
        paddingRight: 5,
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid black',
    },
    termsColumn1: {
        display: 'flex',
        minWidth: '50%',
        maxWidth: '50%',
        paddingRight: '5px',
        fontSize: '7',
        textAlign: 'justify',
        paddingTop: 5,
        paddingBottom: 5,
    },
    termsColumn2: {
        display: 'flex',
        minWidth: '50%',
        maxWidth: '50%',
        paddingLeft: '5px',
        fontSize: '7',
        textAlign: 'justify',
        paddingTop: 5,
        paddingBottom: 5,
    },
    fontRed: {
        color: 'red',
    },
    textBold: {
        fontFamily: 'Helvetica-Bold'
    },
});

const ReportTitleOC = ({ header, view, _user, items }) => {
    let weightTotal = 0;
    for (const item of items) { weightTotal += (Number(item.Weight || 0) * Number(item.Quantity || 0)); }
    // let JrnlMemo = header.JrnlMemo?.includes('Basado en') ? header.JrnlMemo.split('Basado en')[0].trim() : header.JrnlMemo;
    // const isInvt = items?.some(item => item.InvntItem === 'Y') ?? false;
    const hasLlgService = items?.some(item => item.InvntItem === 'N' && Number(item.U_RS_TipoItem) === 1);

    return (
        <>

            <View style={styles.tableContainer}>
                <View style={[styles.content]}>
                    <View style={[styles.col]}>
                        <View style={[styles.content]}>
                            <View style={[styles.col5]}>
                                {/* <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} /> */}
                                <Text style={[styles.textLeft]}>LLAMA GAS S.A.</Text>
                                <Text style={[styles.textLeft]}>Av. El Polo 397 - Santiago de Surco</Text>
                                <Text style={[styles.textLeft]}>LIMA - Lima</Text>
                                <Text style={[styles.textLeft]}>Teléfono: 6171700         Fax: 6171700</Text>
                                <Text style={[styles.textLeft]}>R.U.C.: 20100366747</Text>
                            </View>
                            <View style={[styles.col7, { textAlign: 'left', alignContent: 'left', fontWeight: 'bold' }]}>
                                <Text style={[styles.fontRed, styles.textBold, { fontSize: '11px' }]}>{!hasLlgService ? 'ORDEN DE COMPRA' : 'ORDEN DE SERVICIO'}</Text>
                                {/* <Text>{`${header.SeriesName}`}-{`${header.DocNum}`} - {`${_user?.Sucursal.toUpperCase()} `}</Text> */}
                                <Text>{`${header.SeriesName}`}-{`${header.DocNum}`} - {`${header?.Sucursal?.toUpperCase()} `}</Text>
                            </View>
                        </View>

                        {/* <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                            <View style={[styles.col6, styles.textLeft]}>
                                <Text>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</Text>
                                <Text>{_user?.Branch.Address.toUpperCase()}</Text>
                                <Text>{`C.P. ${_user?.Branch.ZipCode || 'Sin código postal'} `}</Text>
                                <Text>{_user?.Branch.Phone || 'Sin número de teléfono'}</Text>
                            </View>
                            <View style={[styles.col1, styles.textLeft]}>
                            </View>
                            <View style={[styles.col5, styles.textLeft]}>
                                <View style={[styles.content]}>
                                    <View style={[styles.col7]}>
                                        <Text>{`${TitleModal(header.ObjType, header)} N°:`}</Text>
                                    </View>
                                    <View style={[styles.col5]}>
                                        <Text style={{ fontStyle: 'bold' }}>{`${header.DocNum}`}</Text>
                                    </View>
                                </View>
                                {header.ObjType !== '24' && header.ObjType !== '67' && header.ObjType !== '59' && header.ObjType !== '60' && header.ObjType !== "1250000001" &&
                                    <>
                                        <View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Estatus:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.DocStatus === 'C' ? 'Cerrado' : 'Abierto' || ''}`}</Text>
                                            </View>
                                        </View>
                                        < View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Folio:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.NumAtCard || ''}`}</Text>
                                            </View>
                                        </View>
                                    </>
                                }

                            </View>
                        </View> */}

                        {(header.ObjType !== '67' && header.ObjType !== '59' && header.ObjType !== '60' && header.ObjType !== "1250000001") && false &&
                            <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                                <View style={[styles.col5]}>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Cliente: ${header.CardCode || ""} `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Nombre: ${header.CardName || ""} `}</Text>
                                    </View>
                                    <View >
                                        <Text style={[styles.textLeft]}>{`Dirección: ${header.Address || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`RUT: ${header.LicTradNum || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Teléfono: ${header.Phone1 || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Contacto: ${header.CntntName || ""}`}</Text>
                                    </View>
                                </View>
                                <View style={[styles.col7]}>
                                    <View style={[styles.content]}>
                                        <View style={[styles.col4]}>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Fecha: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Condición de Pago: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Moneda: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Lugar de entrega: `}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.col8]}>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.DocDate || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.condicionesPago || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.DocCur || header.DocCurr || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.Address2 || " "}`}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        }


                        <View style={[styles.termsContainer, { marginTop: 1 }]}>
                            <View style={styles.termsColumn1}>
                                <Text style={[styles.textLeft, styles.fontRed, styles.textBold]}>Señores </Text>
                                <Text style={[styles.textLeft]}>Proveedor: {`${header.CardName || ""}`}</Text>
                                <Text style={[styles.textLeft]}>RUC:         {`${header.LicTradNum || ""}`}</Text>
                                <Text style={[styles.textLeft]}>Dirección: {`${header.Address || ""}`}</Text>
                                <Text style={[styles.textLeft]}>Email:      {`${header.E_Mail || ""}`}</Text>
                                <Text style={[styles.textLeft]}>Teléfono:   {`${header.Phone1 || ""}`}</Text>
                                <Text style={[styles.textLeft, styles.fontRed, styles.textBold]}>Contacto:  {`${header.CntntName || ""}`}</Text>
                            </View>

                            <View style={[styles.termsColumn2, { borderLeft: '1px solid black' }]}>
                                <Text style={[styles.textLeft]}>Fecha: {`${header.DocDate ? moment(header.DocDate).utc().format('DD/MM/YYYY') : " "}`}</Text>
                                <Text style={[styles.textLeft]}>Moneda: {`${header.DocCur || header.DocCurr || " "}`}</Text>
                                <Text style={[styles.textLeft]}>Lugar de Entrega: {`${header.LugarEntrega || " "}`}</Text>
                                <Text style={[styles.textLeft]}>Centro Costo: {`${header.CentroCostoNombre || " "}`}</Text>
                                <Text style={[styles.textLeft]}>Área Solicitante: {`${header.AreaSolicitanteOPQT || header.AreaSolicitanteOPOR || " "}`}</Text>
                                <Text style={[styles.textLeft]}>Plazo Entrega: {`${header.DocDate ? moment(header.DocDueDate).utc().format('DD/MM/YYYY') : " "}`}</Text>
                                <Text style={[styles.textLeft]}>Condición de Pago: {`${header.condicionesPago || " "}`}</Text>
                            </View>
                        </View>

                        <Text style={[styles.textLeft, { paddingTop: 1 }]}>Solicita: {`${header?.SolicitanteOPQT || header?.SolicitanteOPOR || " "}`}</Text>
                        <Text style={[styles.textLeft]}>Gestor: {`${header?.Gestor || header?.SlpName || " "}`}</Text>
                        <Text style={[styles.textLeft, styles.fontRed, styles.textBold]}>Sirvanse remitirnos lo siguiente:</Text>

                    </View>
                </View>
            </View>
        </>);
}

export default ReportTitleOC;